import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import BASE_URL from '../../constants/Config';

const FULL_BASE_URL = `${BASE_URL}/api/OurServices`; // Gerekirse bu URL'yi değiştirin

interface Service {
  id: number;
  title: string;
  content: string;
  photoUrl: string; // Fotoğrafın tam URL'si backend'den dönecek
}

interface ServiceState {
  services: Service[];
  loading: boolean;
}

const initialState: ServiceState = {
  services: [],
  loading: false,
};

// Hizmetleri getirme
export const fetchServices = createAsyncThunk('service/fetchServices', async () => {
  const response = await axios.get(`${FULL_BASE_URL}/findall`);
  return response.data; // Backend'den gelen tüm hizmetler
});

// Yeni bir hizmet oluşturma
export const createService = createAsyncThunk(
  'service/createService',
  async (formData: FormData) => {
    const response = await axios.post(`${FULL_BASE_URL}/save`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data; // Yeni eklenen hizmet bilgisi
  }
);

// Bir hizmeti silme
export const deleteService = createAsyncThunk(
  'service/deleteService',
  async (serviceId: number) => {
    await axios.delete(`${FULL_BASE_URL}/delete`, {
      data: {
        token: localStorage.getItem('token'),
        ourServicesId: serviceId,
      },
    });
    return serviceId; // Silinen hizmetin ID'si
  }
);

const serviceSlice = createSlice({
  name: 'service',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchServices.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchServices.fulfilled, (state, action) => {
        state.services = action.payload;
        state.loading = false;
      })
      .addCase(fetchServices.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createService.fulfilled, (state, action) => {
        state.services.push(action.payload);
      })
      .addCase(deleteService.fulfilled, (state, action) => {
        state.services = state.services.filter(service => service.id !== action.payload);
      });
  },
});

export default serviceSlice.reducer;
